import React, { useState, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import {
  H2,
  P,
  Icon,
  Modal,
  ModalHeader,
  ModalBody,
  Grid,
  FlexRow,
  StyledToast,
  BaseCol
} from '@contently/toolkit';
import styled from '@emotion/styled';
import { ToastContainer } from 'react-toastify';
import { generateLink, validateStoredRegion, VALID_REGIONS, US_AND_CANADA } from '../value/utils';
import FilterWrapper from '../value/filter_wrapper';
import { paramTimeHelper } from '../value/timelineHelpers';
import TableWrapper from './table_wrapper';
import CsvDownloadButton from '../value/CsvDownloadButton';

const SpacedRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3.5rem;
`;

const StoryLevelWrapper = ({ appData }) => {
  const {
    story_level_table: tableInfo,
    pub_traffic_value_avg: trafficValAvg,
    pub_id: pubId
  } = JSON.parse(appData);

  const storedRegion = localStorage.getItem('contentValueRegion');
  validateStoredRegion(storedRegion);
  const [filterState, setFilterState] = useState(storedRegion || US_AND_CANADA);
  const [modal, setModal] = useState(false);
  const region = VALID_REGIONS.find(reg => storedRegion === reg);
  const csvDateParam = paramTimeHelper(4);
  const queryParams = { region, month_count: csvDateParam };
  const csvLink = generateLink(queryParams, `analytics/${pubId}/value/story_level_csv?`);

  return (
    <Fragment>
      <StyledToast>
        <ToastContainer />
      </StyledToast>
      <Modal isOpen={modal} onClose={() => setModal(false)}>
        <ModalHeader>
          <H2>Story Content Value</H2>
        </ModalHeader>
        <ModalBody>
          <P>
            This page tracks the Content Value of individual stories. To learn more about the
            metrics that appear on this page, visit{' '}
            <a href="https://contently-support.kayako.com/article/944-understanding-and-improving-your-content-value-dashboard">
              this article
            </a>{' '}
            in Contently&apos;s help center.
          </P>
        </ModalBody>
      </Modal>
      <SpacedRow>
        <H2>
          Story Content Value
          <Icon type="question-circle" onClick={() => setModal(true)} />
        </H2>
        <FlexRow>
          <FilterWrapper filterState={filterState} setFilterState={setFilterState} />
          <CsvDownloadButton csvLink={csvLink} downloadBoxMargin="3.5rem" />
        </FlexRow>
      </SpacedRow>
      <Grid>
        <FlexRow>
          <BaseCol>
            <TableWrapper
              region={filterState}
              tableInfo={tableInfo}
              trafficValAvg={trafficValAvg}
              header="Traffic Value by Content Pillar"
            />
          </BaseCol>
        </FlexRow>
      </Grid>
    </Fragment>
  );
};

export default StoryLevelWrapper;

StoryLevelWrapper.propTypes = {
  appData: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/story_level_wrapper.jsx